module.exports = __webpack_public_path__ + "img/product_60.a986213.webp";